import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface TariffPlan {
  id: string;
  name: string;
  description: string;
  calls: string;
  sms: string;
  data: string;
  price: number;
  dataPerDay: string;
  validity: string;
}

interface PaymentCard {
  name: string;
  lastFour: string;
  icon: string;
}

@Component({
  selector: 'app-mobile-recharge-form',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './mobile-recharge-form.html',
  styleUrl: './mobile-recharge-form.scss',
})
export class MobileRechargeForm implements OnInit {
  @Input() category: any;
  @Output() close = new EventEmitter<void>();
  @Output() back = new EventEmitter<any>();

  step: 'mobile-number' | 'tariffs' | 'review' | 'mobile-categories' = 'mobile-number';

  mobileNumber: string = '';
  selectedPlan: TariffPlan | null = null;
  fee: number = 25.00;

  // ── Card dropdown ──────────────────────────────────────────
  showCardDropdown = false;

  selectedCard: PaymentCard = { name: 'Credit Card 1', lastFour: '1234', icon: 'assets/icons/card.svg' };

  paymentCards: PaymentCard[] = [
    { name: 'Credit Card 1', lastFour: '1234', icon: 'assets/icons/card.svg' },
    { name: 'Debit Card 1', lastFour: '5678', icon: 'assets/icons/card.svg' },
    { name: 'HDFC Savings', lastFour: '9012', icon: 'assets/icons/img-bank.svg' },
    { name: 'ICICI Account', lastFour: '3456', icon: 'assets/icons/img-bank.svg' }
  ];

  toggleCardDropdown(): void {
    this.showCardDropdown = !this.showCardDropdown;
  }

  selectCard(card: PaymentCard): void {
    this.selectedCard = card;
    this.showCardDropdown = false;
  }
  // ──────────────────────────────────────────────────────────

  recentPayments: string[] = ['+9876543210', '+9876543210', '+9876543210'];

  tariffPlans: TariffPlan[] = [
    {
      id: 'plan1',
      name: 'Vi SuperHero',
      description: 'Unlimited local STD & Roaming Calls',
      calls: 'Unlimited local STD',
      sms: '100/Day',
      data: 'Unlimited 5G',
      price: 870,
      dataPerDay: '2GB/day',
      validity: '365 Days',
    },
    {
      id: 'plan2',
      name: 'Vi SuperHero',
      description: 'Unlimited local STD & Roaming Calls',
      calls: 'Unlimited local STD',
      sms: '100/Day',
      data: 'Unlimited 5G',
      price: 1399,
      dataPerDay: '2GB/day',
      validity: '365 Days',
    },
    {
      id: 'plan3',
      name: 'Vi SuperHero',
      description: 'Unlimited local STD & Roaming Calls',
      calls: 'Unlimited local STD',
      sms: '100/Day',
      data: 'Unlimited 5G',
      price: 178,
      dataPerDay: '2GB/day',
      validity: '365 Days',
    },
    {
      id: 'plan4',
      name: 'Vi SuperHero',
      description: 'Unlimited local STD & Roaming Calls',
      calls: 'Unlimited local STD',
      sms: '100/Day',
      data: 'Unlimited 5G',
      price: 178,
      dataPerDay: '2GB/day',
      validity: '365 Days',
    },
    {
      id: 'plan5',
      name: 'Vi SuperHero',
      description: 'Unlimited local STD & Roaming Calls',
      calls: 'Unlimited local STD',
      sms: '100/Day',
      data: 'Unlimited 5G',
      price: 178,
      dataPerDay: '2GB/day',
      validity: '365 Days',
    }
  ];

  ngOnInit(): void { }

  get operatorName(): string {
    return this.category?.name || 'Aircel';
  }

  get isMobileValid(): boolean {
    return this.mobileNumber.length >= 10;
  }

  selectRecentPayment(num: string): void {
    this.mobileNumber = num.replace('+', '');
  }

  goToTariffs(): void {
    if (this.isMobileValid) {
      this.step = 'tariffs';
    }
  }

  selectPlan(plan: TariffPlan): void {
    this.selectedPlan = plan;
    this.fee = plan.price * 0.02;
    this.step = 'review';
  }

  goBack(): void {
    if (this.step === 'tariffs') {
      this.step = 'mobile-number';
    } else if (this.step === 'review') {
      this.step = 'tariffs';
    } else {
      this.back.emit('mobile-form');
    }
  }

  confirm(): void {
    /*console.log('Recharge confirmed:', {
      number: this.mobileNumber,
      plan: this.selectedPlan,
      card: this.selectedCard,
    });*/
    this.back.emit('mobile-categories');
    this.mobileNumber = '';
    this.selectedPlan = null;
  }

  onClose(): void {
    this.close.emit();
  }
}
